import React from 'react';
import { ArrowRight } from 'lucide-react';

/** SectionProjectsCard – Single project card. Data from SectionProjects. */
export default function SectionProjectsCard({ title, description, tags, href, badge, client }) {
  return (
    <article
      className="p-5 rounded-xl border h-full flex flex-col transition-all hover:border-cyan/30"
      style={{ background: 'var(--jb-forest-card)', borderColor: 'var(--jb-border)' }}
    >
      {(badge || client) && (
        <div className="flex flex-wrap items-center gap-2 mb-2">
          {badge && (
            <span
              className="font-mono text-[0.65rem] uppercase tracking-wider px-2 py-0.5 rounded-full"
              style={{ background: 'var(--jb-cyan-dim)', color: 'var(--jb-cyan)' }}
            >
              {badge}
            </span>
          )}
          {client && <span className="font-body text-xs text-text-muted">{client}</span>}
        </div>
      )}
      <h3 className="font-display font-bold text-lg text-text-hero mb-2">{title}</h3>
      <p className="font-body text-text-sub text-sm flex-grow leading-relaxed">{description}</p>
      {tags && tags.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {tags.map((tag, i) => (
            <span key={i} className="font-mono text-xs text-cyan border rounded px-2 py-0.5" style={{ borderColor: 'var(--jb-border)' }}>
              {tag}
            </span>
          ))}
        </div>
      )}
      {href && (
        <a
          href={href}
          className="inline-flex items-center gap-1 mt-3 font-body font-semibold text-cyan hover:opacity-90 text-sm"
        >
          Read more <ArrowRight className="w-4 h-4" />
        </a>
      )}
    </article>
  );
}
